"use client";

import { LoadingProvider } from "@/context/LoadingContext";
import GlobalLoader from "@/components/ui/GlobalLoader";

export default function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <LoadingProvider>
      {children}
      <GlobalLoader />
    </LoadingProvider>
  );
}
